// extracted by mini-css-extract-plugin
export default {"summaryLine":"styles_summaryLine__zb0k5","keyVal":"styles_keyVal__A5Ms3","label":"styles_label__xUINW","summaryLineIcon":"styles_summaryLineIcon__eYipN"};